import { ArrowRight, Flag, PartyPopper } from 'lucide-react';
import { Barre, Section, TEINTES, criteresDe, idsDe } from './constantes';

const AFaire = ({ guide, progression, onAller }) => {
  const restants = guide.blocs.flatMap((b) => criteresDe(b).map((c) => ({ b, c, n: c.indicateurs.filter((i) => progression.ind(i.id).statut !== 'pret').length })))
    .filter((x) => x.n > 0);
  if (!restants.length) {
    return <p className="flex items-center gap-2 rounded-xl bg-emerald-50 p-4 text-sm font-semibold text-emerald-700" data-testid="guide-tout-pret"><PartyPopper className="h-5 w-5" /> Tous les indicateurs sont prêts : faites relire votre dossier par votre formateur.</p>;
  }
  return (
    <ul className="divide-y divide-slate-100 rounded-xl border border-slate-200" data-testid="guide-reste-a-faire">
      {restants.map(({ b, c, n }) => (
        <li key={c.cle}>
          <button type="button" onClick={() => onAller(b.code, c.cle)} data-testid={`guide-reste-${c.cle}`}
            className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors hover:bg-slate-50">
            <span className={`rounded-lg px-2 py-1 text-xs font-bold text-white ${TEINTES[b.couleur].fort}`}>{c.code}</span>
            <span className="min-w-0 flex-1 text-slate-700">{c.court}</span>
            <span className="text-xs text-slate-400">{n} à préparer</span><ArrowRight className="h-4 w-4 text-slate-400" />
          </button>
        </li>
      ))}
    </ul>
  );
};

export const OngletSynthese = ({ guide, progression, onAller }) => (
  <div className="space-y-6" data-testid="guide-synthese">
    <div className="rounded-2xl border-t-4 border-[#8DC63F] bg-[#0F172A] p-6 text-white sm:p-8">
      <h2 className="flex items-center gap-2 text-2xl font-bold sm:text-3xl"><Flag className="h-6 w-6 text-[#8DC63F]" /> Synthèse finale</h2>
      <ol className="mt-6 space-y-3">
        {guide.synthese.map((x, k) => <li key={x} className="flex gap-3 rounded-xl bg-white/5 p-3.5 text-sm text-white/90 sm:text-base"><span className="font-bold text-[#8DC63F]">{k + 1}</span>{x}</li>)}
      </ol>
    </div>
    <Section titre="Où en êtes-vous ?" testId="guide-bilan-progression">
      <div className="grid gap-4 sm:grid-cols-2">
        {guide.blocs.map((b) => {
          const { pret, enCours, total } = progression.compte(idsDe(criteresDe(b)));
          return (
            <div key={b.code} className="rounded-xl bg-slate-50 p-4" data-testid={`guide-bilan-${b.code}`}>
              <p className="flex justify-between text-sm font-bold text-[#0F172A]"><span>{b.code} · {b.court}</span><span>{pret}/{total}</span></p>
              <Barre pret={pret} total={total} couleur={TEINTES[b.couleur].barre} className="mt-2" />
              <p className="mt-2 text-xs text-slate-500">{enCours} en cours · {total - pret - enCours} pas commencés</p>
            </div>
          );
        })}
      </div>
    </Section>
    <Section titre="Ce qu'il vous reste à préparer" sousTitre="Cliquez sur un critère pour l'ouvrir."><AFaire guide={guide} progression={progression} onAller={onAller} /></Section>
  </div>
);
